module.exports = __webpack_public_path__ + "static/media/socialmediaMarketing.b206b481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Mtechold/socialmediaMarketing.jpg
// module id = 335
// module chunks = 0